import React, { useRef } from "react";
import { gsap } from "gsap";
import { connect } from "react-redux";
import $, { event } from "jquery";
import * as actionCreators from "../../../store/actions/index";

import "./Answer.scss";

const Answer = (props) => {
  const radioGroup = useRef();
  const animateAnswers = (pnlIdx, rdIdx) => {
    const animateThese = $(`.Answer--${pnlIdx}`).filter((i, answer) => {
      if (i !== Number(rdIdx)) {
        return answer;
      }
    });

    gsap.to(`.Answer--${pnlIdx}`, {
      opacity: 1,
      duration: 0.5,
    });
    gsap.to(animateThese, {
      opacity: 0.7,
      duration: 0.5,
    });
  };
  const answerInputHandlr = (panelIdx, radioIdx) => {

    gsap
      .to(`#Next_${props.pnlIdx}`, {
        opacity: 1,
        pointerEvents: "all",
        duration: 1
      })
      .delay(0.5);
      //ACC
      document.getElementById(`Next_${props.pnlIdx}`).disabled = false;
      document.getElementById(`qA--${props.pnlIdx}-${props.ansIdx}`).ariaChecked=true;

    animateAnswers(panelIdx, radioIdx);
    props.onUpdateScore(props.pnlIdx, props.value);
  };

  const handleEnter = (event) =>{
    var id=document.activeElement.id;
    document.getElementById(document.activeElement.id).click();

  }




  return (
    <div ref={radioGroup} className={`Answer Answer--${props.pnlIdx}`} >
      <input
        type="radio"
        id={`qA--${props.pnlIdx}-${props.ansIdx}`}
        name={`qA--${props.pnlIdx}`}
        className={`Answer__radio Answer__radio${props.pnlIdx}`}
        onClick={() => answerInputHandlr(`${props.pnlIdx}`, `${props.ansIdx}`)}
        onKeyPress={()=> handleEnter()}
        onChange={props.changeHandlr}
        value={props.value}
        aria-checked="false"
      />
      <label
        className="Answer__label"
        htmlFor={`qA--${props.pnlIdx}-${props.ansIdx}`}
      >
        <div
          className="Answer__radio--faux"
          name={`qA--${props.pnlIdx}-${props.ansIdx}`}
        ></div>
        <div className="Answer__txt">{props.answer}</div>
      </label>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    onUpdateScore: (i, v) => dispatch(actionCreators.update_score(i, v)),
  };
};

export default connect(null, mapDispatchToProps)(Answer);
